import React, { useState, useEffect } from 'react';
import { Box, Button, TextField, SelectChangeEvent } from '@mui/material';
import Dropdown from '../../Components/DropDown/drop-down.tsx';
import { getDevicesSim } from './action.ts'; 

interface AddDeploymentModalProps {
    companyOptions: { id: string; label: string }[];
    selectedCompany: string;
    handleCompanyChange: (event: SelectChangeEvent<string>) => void;
    
    platformModelOptions: { id: string; label: string }[];
    deploymentDevice: string;
    setDeploymentDevice: (val: string) => void;
    
    vehicleOptions: { id: string; label: string }[];
    selectedVehicle: string;
    setSelectedVehicle: (val: string) => void;
    
    assignedUserOptions: { id: string; label: string }[];
    selectedAssignedUser: string;
    setSelectedAssignedUser: (val: string) => void;


    
    remarks: string;
    setRemarks: (val: string) => void;
    handleSaveDeployment: (deviceId: any, simId: any) => void;
}

const AddDeploymentModal: React.FC<AddDeploymentModalProps> = ({
    companyOptions,
    selectedCompany,
    handleCompanyChange,
    platformModelOptions,
    deploymentDevice,
    setDeploymentDevice,
    vehicleOptions,
    selectedVehicle,
    setSelectedVehicle,
    assignedUserOptions,
    selectedAssignedUser,
    setSelectedAssignedUser,

    remarks,
    setRemarks,
    handleSaveDeployment,
}) => {
    const [deviceOptions, setDeviceOptions] = useState<{ id: string; label: string }[]>([]);
    const [simOptions, setSimOptions] = useState<{ id: string; label: string }[]>([]);
    const [selectedDevice, setSelectedDevice] = useState<string>('');
    const [selectedSim, setSelectedSim] = useState<string>('');

useEffect(() => {
        if (deploymentDevice) {
            getDevicesSim(
                deploymentDevice,
                'unallocated',
                1, 
                '', 
                100,
                0,
                (response) => {
                    if (response?.data?.devices) {
                        const mappedDevices = response.data.devices.map((device: any) => ({
                            id: device.device_id,
                            label: device.device_imei || `Device ${device.device_id}`
                        }));
                        setDeviceOptions(mappedDevices);
                    }
                    
                    if (response?.data?.sims) {
                        const mappedSims = response.data.sims.map((sim: any) => ({
                            id: sim.sim_id || sim.id, 
                            label: sim.sim_number || sim.iccid || `SIM ${sim.sim_id || sim.id}`
                        }));
                        setSimOptions(mappedSims);
                    }
                },
                (error) => {
                    console.error("Failed to load devices/sims:", error);
                }
            );
        }
    }, [deploymentDevice]); 

    useEffect(() => {
        getDevicesSim(
            '', 
            'active',
            '', 
            1, 
            100, 
            0,
            (response) => {
                if (response?.data?.devices) {
                    const mappedDevices = response.data.devices.map((device: any) => ({
                        id: device.device_id,
                        label: device.device_imei || `Device ${device.device_id}`
                    }));
                    setDeviceOptions(mappedDevices);
                }
                
                if (response?.data?.sims) {
                    const mappedSims = response.data.sims.map((sim: any) => ({
                        id: sim.sim_id || sim.id, 
                        label: sim.sim_number || sim.iccid || `SIM ${sim.sim_id || sim.id}`
                    }));
                    setSimOptions(mappedSims);
                }
            },
            (error) => {
                console.error("Failed to load devices/sims:", error);
            }
        );
    }, []);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1, pb: 2, justifyContent: 'center', alignItems: 'center' }}>
            <Box>
                <Dropdown 
                    options={companyOptions}
                    selectedValue={selectedCompany}
                    handleChange={handleCompanyChange}
                    placeholder="Select Company"
                    label="Choose Company"
                    height="40px"
                    width="250px"
                    searchable={true}
                />
            </Box>
            
            <Box>
                <Dropdown 
                    options={platformModelOptions}
                    selectedValue={deploymentDevice}
                    handleChange={(e: SelectChangeEvent<string>) => setDeploymentDevice(e.target.value)}
                    placeholder="Select Device Type"
                    label="Device Type"
                    height="40px"
                    width="250px"
                />
            </Box>
            
            <Box>
                <Dropdown 
                    options={deviceOptions}
                    selectedValue={selectedDevice}
                    handleChange={(e: SelectChangeEvent<string>) => setSelectedDevice(e.target.value)}
                    placeholder="Select Device"
                    label="Device"
                    height="40px"
                    width="250px"
                    searchable={true}
                />
            </Box>

            <Box>
                <Dropdown 
                    options={simOptions}
                    selectedValue={selectedSim}
                    handleChange={(e: SelectChangeEvent<string>) => setSelectedSim(e.target.value)}
                    placeholder="Select SIM"
                    label="SIM"
                    height="40px"
                    width="250px"
                    searchable={true}
                />
            </Box>
            
            <Box>
                <Dropdown 
                    options={vehicleOptions}
                    selectedValue={selectedVehicle}
                    handleChange={(e: SelectChangeEvent<string>) => setSelectedVehicle(e.target.value)}
                    placeholder={selectedCompany ? "Select Vehicle" : "Select a Company First"}
                    label="Vehicle Number"
                    height="40px"
                    width="250px"
                    searchable={true}
                    disabled={!selectedCompany || vehicleOptions.length === 0}
                />
            </Box>

            <Box>
                <Dropdown 
                    options={assignedUserOptions}
                    selectedValue={selectedAssignedUser}
                    handleChange={(e: SelectChangeEvent<string>) => setSelectedAssignedUser(e.target.value)}
                    placeholder="Select Assigned User"
                    label="Assign User"
                    height="40px"
                    width="250px"
                    searchable={true}
                    disabled={!selectedCompany || assignedUserOptions.length === 0}
                />
            </Box>
            
            <Box>
                <TextField 
                    label="Remarks" 
                    size="small" 
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    multiline
                    rows={2}
                    sx={{ width: '250px' }} 
                />
            </Box>
            
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
<Button variant="contained" className="custom-button" onClick={() => handleSaveDeployment(selectedDevice, selectedSim)}>                    Save Deployment
                </Button>
            </Box>
        </Box>
    );
};

export default AddDeploymentModal;